import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import de from './translations/de'
import en from './translations/en'
import fr from './translations/fr'
import it from './translations/it'
import nl from './translations/nl'
import { LanguageCode, LanguageOption } from './types'

import dutchFlag from '../../assets/static/images/flags/dutch-flag.png'
import englishFlag from '../../assets/static/images/flags/english-flag.png'
import frenchFlag from '../../assets/static/images/flags/french-flag.png'
import germanFlag from '../../assets/static/images/flags/german-flag.png'
import italianFlag from '../../assets/static/images/flags/italian-flag.png'

export const defaultLanguage = 'nl'

export const languages: Record<LanguageCode, LanguageOption> = {
  en: { nameKey: 'languageNames.en', flag: englishFlag },
  nl: { nameKey: 'languageNames.nl', flag: dutchFlag },
  de: { nameKey: 'languageNames.de', flag: germanFlag },
  fr: { nameKey: 'languageNames.fr', flag: frenchFlag },
  it: { nameKey: 'languageNames.it', flag: italianFlag },
}

// Initialize i18n
i18n
  .use(LanguageDetector) // Detects user language
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: en,
      },
      nl: {
        translation: nl,
      },
      de: {
        translation: de,
      },
      fr: {
        translation: fr,
      },
      it: {
        translation: it,
      },
    },
    fallbackLng: defaultLanguage,
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  })

export default i18n
